import { ResolveFn } from '@angular/router';
import { AdcvdProduct } from './adcvd-types';

// A resolver, not ngOnInit: the router waits for it, so server rendering always has the data.
// The data is one lazy chunk; the route's canMatch has already checked the product exists.
// adcvd-copy is imported on demand so the index stays out of the main bundle.
export const adcvdResolver: ResolveFn<AdcvdProduct | undefined> = async route => {
  const { findAdcvd } = await import('./adcvd-copy');
  const entry = findAdcvd(route.paramMap.get('product'));
  if (!entry) return undefined;
  const m = await import('./adcvd-data');
  return m.ADCVD_PRODUCTS.find(p => p.slug === entry.slug);
};
